import styled from "styled-components";
import { theme } from "../../../../../constants/StyledComponents";

export const StyledWriteNote = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 20px;
  padding: 20px;
  box-sizing: border-box;
  background-color: ${theme.colors.white};
  border-top: 1px solid ${theme.colors.purple_2};
`;

export const StyledBodyNotes = styled.div`
  width: 100%;
`;

export const StyledScrollableContainer = styled.div`
  overflow-y: auto;
  max-height: calc(100dvh - 419px);
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
